import { TouchPointHelper } from '../../../helpers/touchPointHelper';
import { displayGroups } from '@ui';

export const _root = {
	prismName: '_root',
	template: {
		templateName: '_rootTemplate',
		displayGroups: [TouchPointHelper.createDisplayGroup(displayGroups.pageContainer, [], [])],
	},
};
